import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SchedulerStageApiService } from '../api/view.service';
import { AlertService } from '../../../core/services/alert.service';
import { LayoutService } from '../../../core/services/layout.service';
import {
  distinctUntilChanged,
  finalize,
  switchMap,
  take,
} from 'rxjs/operators';
import { RoutingService } from '../../../core/services/routing.service';
import { QualityControlSubWorkOrder } from '../../../common/quality-control/model/sub-work-order-qc.ts';

@Injectable()
export class SchedulerStageViewService {
  protected readonly apiRoute = inject(SchedulerStageApiService);
  protected readonly alertService = inject(AlertService);
  protected readonly layoutService = inject(LayoutService);
  protected readonly routerService = inject(RoutingService);

  protected columns = [
    'rank',
    'workOrder',
    'itemName',
    'endDate',
    'quantityAvailable',
    'options',
  ];

  get displayedColumns(): string[] {
    return [...this.columns];
  }

  private _items = new BehaviorSubject<QualityControlSubWorkOrder[]>([]);
  items$ = this._items.asObservable();

  routerStage$ = this.routerService
    .getRouteData<string>('stageName')
    .pipe(distinctUntilChanged());

  constructor() {}

  update(): void {
    this.layoutService.setLoading(true);
    this.routerStage$
      .pipe(
        take(1),
        switchMap((stage) => this.apiRoute.getSchedulerData(stage)),
        finalize(() => this.layoutService.setLoading(false))
      )
      .subscribe({
        next: (data) => {
          this._items.next(data);
        },
        error: (err) => {
          this.alertService.error('Error al obtener la informacion' + err);
        },
      });
  }
}
